export const TIME_OPTIONS = [
  { label: "Menos de 15 minutos", value: "lt15", minutes: 7.5 },
  { label: "15-30 minutos", value: "15-30", minutes: 22.5 },
  { label: "30-60 minutos", value: "30-60", minutes: 45.0 },
  { label: "Más de 1 hora", value: "gt60", minutes: 75.0 },
  { label: "No estoy seguro/a", value: "unsure", minutes: 0 },
];

export const DAY_OPTIONS = [0, 1, 2, 3, 4, 5, 6, 7].map((d) => ({
  label: d === 0 ? "0 días" : d === 1 ? "1 día" : `${d} días`,
  value: String(d),
}));

export const SITTING_OPTIONS = [
  { label: "Menos de 2 horas", value: "lt2", category: "Bajo", color: "#157346", key: "low" },
  { label: "2 a 4 horas", value: "2-4", category: "Moderado", color: "#F9A01B", key: "moderate" },
  { label: "4 a 6 horas", value: "4-6", category: "Alto", color: "#F9A01B", key: "high" },
  { label: "Más de 6 horas", value: "gt6", category: "Muy alto", color: "#C0453A", key: "very_high" },
  { label: "No estoy seguro/a", value: "unsure", category: "Sin dato", color: "#B5A998", key: "unknown" },
];

function getMinutes(timeValue) {
  const opt = TIME_OPTIONS.find((o) => o.value === timeValue);
  return opt ? opt.minutes : 0;
}

export function calculateMET(factor, daysStr, timeValue) {
  if (!daysStr || daysStr === "0") return 0;
  if (!timeValue || timeValue === "unsure") return null;
  const d = parseInt(daysStr);
  const mins = getMinutes(timeValue);
  if (isNaN(d) || d === 0 || mins === 0) return 0;
  return Math.round(factor * d * mins);
}

export function classifyIPAQ(metVig, metMod, metWalk) {
  const vig = metVig || 0;
  const mod = metMod || 0;
  const walk = metWalk || 0;
  const total = vig + mod + walk;

  if (metVig !== null && vig >= 1500) {
    return { label: "Alto (activo)", color: "#157346", key: "high", metTotal: total };
  }
  if (total >= 3000) return { label: "Alto (activo)", color: "#157346", key: "high", metTotal: total };
  if (total >= 600) return { label: "Moderado", color: "#F9A01B", key: "moderate", metTotal: total };
  return { label: "Bajo (inactivo)", color: "#C0453A", key: "low", metTotal: total };
}

export function getSittingCategory(value) {
  return SITTING_OPTIONS.find((o) => o.value === value) || null;
}
